@if (
  (type === 'Point' && dataLayerTypeStore.pointLayers()) ||
    (type === 'Polygon' && dataLayerTypeStore.polygonLayers());
  as types
) {
  @if (types.length > 0) {
    <p-pickList
      class="app-pick-list"
      [source]="items"
      [target]="selected"
      [dragdrop]="true"
      [responsive]="true"
      [showSourceControls]="showSourceControls"
      [showTargetControls]="showTargetControls"
      (onMoveToSource)="updateSelection()"
      (onMoveToTarget)="updateSelection()"
      (onMoveAllToSource)="updateSelection()"
      (onMoveAllToTarget)="updateSelection()"
      [sourceStyle]="{ height: '30rem' }"
      [targetStyle]="{ height: '30rem' }"
      breakpoint="1400px">
      <ng-template pTemplate="sourceHeader">
        <app-pick-list-header
          [title]="type === 'Point' ? 'Standorte' : 'Räume'"
          [count]="items.length" />
      </ng-template>
      <ng-template pTemplate="targetHeader">
        <app-pick-list-header title="Auswahl" [count]="selected.length" />
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="pl-row">
          <span class="pl-icon">
            @if (type === 'Point') {
              <app-svg-icon [key]="item.icon" />
            } @else {
              <i [class]="item.icon"></i>
            }
          </span>
          <span class="pl-name">{{ item.label }}</span>
        </div>
      </ng-template>
      <ng-template pTemplate="emptymessagesource">
        <div class="pl-empty">Keine weiteren Einträge.</div>
      </ng-template>
      <ng-template pTemplate="emptyfiltermessagesource">
        <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
      </ng-template>
      <ng-template pTemplate="emptymessagetarget">
        <div class="pl-empty">
          Noch nichts ausgewählt – per Doppelklick, Pfeil oder Ziehen
          übernehmen.
        </div>
      </ng-template>
      <ng-template pTemplate="emptyfiltermessagetarget">
        <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
      </ng-template>
    </p-pickList>
  } @else {
    <app-alert styleClass="m-0 p-3" [canToggle]="false" severity="secondary">
      @if (type === 'Point') {
        Keine Standorte gefunden
      } @else {
        Keine Räume gefunden
      }
    </app-alert>
  }
}
